import forms from './forms.json';
import general from './general.json';
import alerts from './alerts.json';
import toasts from './toasts.json';
import modals from './modals.json';
import router_file from './router_file.json';
import gotedo_table_definitions from './gotedo_table_definitions.json';
import onboarding_data_migration_module from './onboarding_data_migration_module.json';

export default {
  forms,
  general,
  alerts,
  toasts,
  modals,
  router_file,
  gotedo_table_definitions,
  onboarding_data_migration_module,
};
